import { resolveCertificateIcon } from '../../utils/certificateUtils';

export default function Certificates({ t }) {
  const certificates = t.certificates;

  return (
    <section id="certificates" className="premium-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-tag">Achievements</span>
          <h3 className="section-title">{t.certTitle}</h3>
        </div>
        <div className="premium-grid">
          {Array.isArray(certificates) && certificates.map((cert, idx) => {
            const certIcon = resolveCertificateIcon(cert.issuer, cert.icon);

            return (
              <div key={cert.id || `cert-${idx}`} className="premium-card card-animated">
                <div className="card-gradient-border"></div>
                <div className="card-icon">
                  {certIcon ? (
                    <img src={certIcon} alt={cert.title} />
                  ) : (
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>
                  )}
                </div>
                <h4 className="card-title">{cert.title}</h4>
                <span className="cert-issuer">{cert.issuer}</span>
                <p className="cert-date">{cert.date}</p>
                <div className="cert-skills">
                  {cert.skills && cert.skills.split('·').map((skill, i) => (
                    <span key={i} className="cert-skill-tag">{skill.trim()}</span>
                  ))}
                </div>
                {cert.image && (
                  <img src={cert.image} alt={cert.title} className="cert-image" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
